import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_SurveyComponentBase } from '../Renderer_SurveyComponentBase/Renderer_SurveyComponentBase.js';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/index';
import './Renderer_SurveyComponentFreeText.scss';
import { SurveyQuestion_FreeText } from '@app/advisor-shared';
export class Renderer_SurveyComponentFreeText extends Renderer_SurveyComponentBase {
    componentType = SurveyQuestion_FreeText;
    renderInput = () => {
        return _jsx(TS_TextAreaV2, { placeholder: 'Type here', value: this.state.currentValue, resizeWithText: true, onChange: content => this.props.onChange(content) });
    };
}
//# sourceMappingURL=Renderer_SurveyComponentFreeText.js.map